import type { Dispatch } from '@reduxjs/toolkit';
import type { RootState } from '../../../configuration/setup/store';
import { setPersonalInfoField, touchPersonalInfoField } from '../personalInfoSlice';
import { resolveExamplePhoneNumber } from './personalElementsUtils';

export const mapStateToPersonalFirstNameProps = (state: RootState) => {
    return {
        fieldValue: state.personalInfo.firstName,
        fieldValid: !!state.personalInfo.firstNameValidationMessage,
        fieldTouched: !!state.personalInfo.firstNameTouched,
        fieldLabel: 'intl-msg:registration.personalData.firstName',
        name: 'personalFirstName',
    };
};

export const mapDispatchToPersonalFirstNameProps = (dispatch: Dispatch) => ({
    setFieldValue: (newFirstName: string) =>
        dispatch(setPersonalInfoField({ fieldName: 'firstName', value: newFirstName })),
    touchField: () => dispatch(touchPersonalInfoField('firstName')),
});

export const mapStateToPersonalLastNameProps = (state: RootState) => ({
    fieldValue: state.personalInfo.lastName,
    fieldValid: !!state.personalInfo.lastNameValidationMessage,
    fieldTouched: !!state.personalInfo.lastNameTouched,
    fieldLabel: 'intl-msg:registration.personalData.lastName',
    name: 'personalLastName',
});

export const mapDispatchToPersonalLastNameProps = (dispatch: Dispatch) => ({
    setFieldValue: (newLastName: string) =>
        dispatch(setPersonalInfoField({ fieldName: 'lastName', value: newLastName })),
    touchField: () => dispatch(touchPersonalInfoField('lastName')),
});

export const mapStateToPersonalEmailProps = (state: RootState) => ({
    fieldValue: state.personalInfo.email,
    fieldValid: state.personalInfo.emailValidationMessage,
    fieldTouched: state.personalInfo.emailTouched,
    fieldLabel: 'intl-msg:registration.personalData.email',
    fieldPlaceholder: 'example@domain.com',
    name: 'personalEmail',
    popoverTooltipMessage: 'intl-msg:registration.tooltip.email.validFormat',
    showPopoverTooltip: true,
});

export const mapStateToPersonalPhoneNumberProps = (state: RootState) => ({
    fieldValue: state.personalInfo.phoneNumber ? state.personalInfo.phoneNumber : '',
    fieldValidationMessage: state.personalInfo.phoneNumberValidationMessage,
    fieldTouched: state.personalInfo.phoneNumberTouched,
    fieldLabel: 'intl-msg:registration.personalData.phoneNumber',
    fieldPlaceholder: resolveExamplePhoneNumber(state.companyInfo.countryCode),
    error: state.personalInfo.phoneNumberValidationMessage ? '' : 'intl-msg:registration.error.phoneNumber.InvalidFormat',
    showPopoverTooltip: true,
    popoverTooltipMessage: 'intl-msg:registration.tooltip.phoneNumber.validFormat',
    name: 'personalPhoneNumber',
});

export const mapDispatchToPersonalEmailProps = (dispatch: Dispatch) => ({
    setFieldValue: (newEmail: string) => dispatch(setPersonalInfoField({ fieldName: 'email', value: newEmail })),
    touchField: () => dispatch(touchPersonalInfoField('email')),
});

export const mapDispatchToPersonalPhoneNumberProps = (dispatch: Dispatch) => ({
    setFieldValue: (newPhoneNumber: string) =>
        dispatch(setPersonalInfoField({ fieldName: 'phoneNumber', value: newPhoneNumber })),
    touchField: () => dispatch(touchPersonalInfoField('phoneNumber')),
});
